import { v4 as uuid } from 'uuid';

import { ACTION_TYPES } from './constants';
import { type ToastState, type ToastActionType } from './types';

const initialState: ToastState = {
    toasts: [],
    lastToastAction: null,
};

function reducer(state: ToastState, action: ToastActionType): ToastState {
    switch (action.type) {
        case ACTION_TYPES.ADD_TOAST:
            /**
             * Currently we don't support stacking toasts, dismissing other existing
             * toasts instantly, so existing toast exit animation would not overlap
             * with new toast entering animation
             */
            return {
                ...state,
                toasts: [
                    {
                        ...action.toast,
                        id: uuid(),
                        isVisible: true,
                    },
                ],
                lastToastAction: action?.toastAction || null,
            };

        case ACTION_TYPES.REMOVE_TOAST:
            return {
                ...state,
                toasts: state.toasts.filter(toast => toast.id !== action.id),
            };

        default:
            return state;
    }
}

export { initialState, reducer };
